// src/helpers/html5QrcodeCamera.ts
// Dừng camera html5-qrcode an toàn — dùng chung cho QrScannerModal và QrScanSessionPage.
//
// Lỗi gốc: Html5Qrcode.stop() THROW ĐỒNG BỘ ("Cannot stop, scanner is not running or paused.") khi camera
// chưa start xong — VD bật camera rồi tắt ngay lúc trình duyệt còn đang hỏi quyền. Lỗi throw trong cleanup
// của useEffect làm React báo lỗi màn hình đỏ. Ngoài ra nếu dừng lúc start còn treo, khi người dùng bấm
// "Cho phép" sau đó thì start mới hoàn tất -> camera bật mà không còn ai tắt (đèn camera sáng mãi).
//
// Cách xử lý: luôn CHỜ lời gọi start() kết thúc (thành công hay thất bại) rồi mới dừng, và chỉ gọi stop()
// khi trạng thái thực sự là đang quét / tạm dừng.

import { Html5Qrcode, Html5QrcodeScannerState } from 'html5-qrcode';

const clearSafely = (qr: Html5Qrcode): void => {
  try {
    qr.clear();
  } catch {
    /* element có thể đã bị gỡ khỏi DOM (modal đóng) — bỏ qua */
  }
};

/**
 * Dừng + dọn 1 instance Html5Qrcode mà không bao giờ throw.
 * @param qr - instance cần dừng
 * @param pendingStart - promise của lời gọi qr.start() (nếu có) — đợi nó xong mới dừng
 * @returns Promise resolve khi camera đã được giải phóng hẳn (dùng để xếp hàng lần start kế tiếp)
 */
export const stopHtml5QrcodeSafely = (qr: Html5Qrcode, pendingStart?: Promise<unknown>): Promise<void> => {
  const doStop = async (): Promise<void> => {
    try {
      const state = qr.getState();
      if (state === Html5QrcodeScannerState.SCANNING || state === Html5QrcodeScannerState.PAUSED) {
        await qr.stop();
      }
    } catch {
      /* camera đã dừng sẵn / element đã bị gỡ — bỏ qua */
    }
    clearSafely(qr);
  };
  return (pendingStart ?? Promise.resolve()).then(doStop, doStop);
};
